var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphicEmailCodemin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227,
    height: 183,
    fill: "none",
    viewBox: "20 10 207 173",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud-shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M166.47 69.583c-.224 0-.446.012-.67.017l.001-.017c0-19.652-16.043-35.583-35.833-35.583-16.071 0-29.67 10.506-34.215 24.978a24.7 24.7 0 0 0-11.481-2.814c-13.63 0-24.68 10.973-24.68 24.508 0 2.205.298 4.34.848 6.373a20 20 0 0 0-8.094-1.712c-11.03 0-19.973 8.88-19.973 19.834S41.315 125 52.346 125H166.47c15.411 0 27.903-12.405 27.903-27.708s-12.492-27.709-27.903-27.709"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007BED",
    d: "m138.52 123.67-12.22 12.41-10.9-10.86-.89-1.09-1.47 1.56-31.97 34.3A6.28 6.28 0 0 0 85.8 162h80.87c1.76 0 3.53-.77 4.71-2.02L140 125.22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#179CF1",
    d: "M114.3 126.17 81.27 94.7a7.25 7.25 0 0 0-1.6 2.96 6.4 6.4 0 0 0-.3 1.77v56.14a6.9 6.9 0 0 0 1.9 4.73l31.57-32.5zm58.57-29.35a8.85 8.85 0 0 0-1.73-2.97L139 125.6l1.44 1.48 30.7 33.23a6.6 6.6 0 0 0 1.88-4.75V98.89c.14-.59 0-1.33-.15-2.07"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DABDFF",
    d: "m114.29 126.64.88.88 10.9 10.48 12.23-11.8L171 94.77a6.23 6.23 0 0 0-4.42-1.77H85.71c-1.76 0-3.53.74-4.71 2.07z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4AA2",
    d: "M205.37 79h-55a15 15 0 0 0 0 30h55a15 15 0 0 0 0-30",
    className: "animate-email-code-fade [animation-delay:900ms]"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m158.76 95.8.7 3.06h-3l.71-3.06-2.34 2.13-1.46-2.6 3-.9-3-.95 1.54-2.55 2.26 2.12-.7-3.05h3l-.74 3.1 2.37-2.17 1.48 2.6-3.1.92 3.1.93-1.53 2.55z",
    className: "animate-email-code-fade [animation-delay:1400ms]"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m171.97 95.8.7 3.06h-3l.71-3.06-2.34 2.13-1.46-2.6 3-.9-3-.95 1.54-2.55 2.26 2.12-.7-3.05h3l-.74 3.1 2.37-2.17 1.48 2.6-3.1.92 3.1.93-1.53 2.55z",
    className: "animate-email-code-fade [animation-delay:1600ms]"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m185.18 95.8.7 3.06h-3l.71-3.06-2.34 2.13-1.46-2.6 3-.9-3-.95 1.54-2.55 2.26 2.12-.7-3.05h2.99l-.73 3.1 2.37-2.17 1.48 2.6-3.1.92 3.1.93-1.53 2.55z",
    className: "animate-email-code-fade [animation-delay:1800ms]"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m198.39 95.8.7 3.06h-3l.71-3.06-2.34 2.13-1.46-2.6 3-.9-3-.95 1.54-2.55 2.26 2.12-.7-3.05h2.99l-.73 3.1 2.37-2.17 1.48 2.6-3.1.92 3.1.93-1.53 2.55z",
    className: "animate-email-code-fade [animation-delay:2000ms]"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "animate-email-code-bounce-scale"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.37,
    cy: 129,
    r: 20,
    fill: "#fff",
    className: "animate-email-code-fade"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "animate-email-code-rotate"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4AA2",
    stroke: "#FF4AA2",
    d: "m81.33 127.69-8.62-8.64a1.85 1.85 0 0 0-2.63 0 1.86 1.86 0 0 0 0 2.62l5.46 5.47H61.73a1.86 1.86 0 0 0-1.86 1.86c0 1.02.83 1.86 1.86 1.86h13.81l-5.46 5.47a1.86 1.86 0 0 0 0 2.62c.73.73 1.9.73 2.63 0l8.62-8.64a1.86 1.86 0 0 0 0-2.62Z",
    className: "animate-email-code-fade"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cloud-shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "glow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "glow",
    values: "0 0 0 0 0  0 0 0 0 0.5  0 0 0 0 1  0 0 0 0.2 0",
    result: "blue-glow"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blue-glow"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicEmailCodemin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_email_code.min.49f856e75094e4b66d6e8dd4c7ba2eeb.svg";